import React from 'react'
import { cn } from '@/lib/utils'

interface MetricCardProps {
  icon: React.ReactNode
  iconBg: string
  label: string
  value: string | number
  subtitle?: string
  progress?: number // 0-100
  progressColor?: string
  alert?: boolean
  className?: string
}

export const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  iconBg,
  label,
  value,
  subtitle,
  progress,
  progressColor = 'bg-primary-500',
  alert = false,
  className,
}) => {
  return (
    <div className={cn(
      'relative p-4 rounded-xl border transition-all',
      alert
        ? 'bg-amber-50 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800'
        : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700',
      className
    )}>
      <div className="flex items-start gap-3">
        <div className={cn('h-9 w-9 rounded-lg flex items-center justify-center flex-shrink-0', iconBg)}>
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
            {label}
          </p>
          <p className={cn(
            'text-xl font-bold mt-0.5',
            alert ? 'text-amber-700 dark:text-amber-300' : 'text-slate-900 dark:text-slate-100'
          )}>
            {value}
          </p>
          {subtitle && (
            <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {progress !== undefined && (
        <div className="mt-3">
          <div className="h-1 bg-slate-100 dark:bg-slate-700 rounded-full overflow-hidden">
            <div
              className={cn('h-full rounded-full transition-all duration-500', progressColor)}
              style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
            />
          </div>
        </div>
      )}
    </div>
  )
}
